<template>
  <div class="container">
    <b-navbar>
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <b-tooltip
            :label="$t('authentication.loggedIn') + authenticatedUser.email"
            position="is-right"
          >
            <b-icon icon="user" size="is-small"> </b-icon>
          </b-tooltip>
        </b-navbar-item>
      </template>

      <template slot="start">
        <!-- <b-navbar-dropdown> -->
        <b-navbar-item tag="router-link" :to="{ path: '/overview' }">
          {{ $t('navigation.overview') }}
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/transactions' }">
          {{ $t('navigation.transactions') }}
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/categories' }">
          {{ $t('navigation.categories') }}
        </b-navbar-item>
        <!-- <b-navbar-item href="#">
          Documentation
        </b-navbar-item>
        <b-navbar-dropdown label="Info">
          <b-navbar-item href="#">
            About
          </b-navbar-item>
          <b-navbar-item href="#">
            Contact
          </b-navbar-item> -->
        <!-- </b-navbar-dropdown> -->
      </template>

      <template slot="end">
        <b-navbar-item tag="router-link" :to="{ path: '/settings' }">
          {{ $t('navigation.settings') }}
        </b-navbar-item>

        <b-navbar-item tag="div">
          <div class="buttons">
            <logout></logout>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logout from '@/components/Logout.vue';

export default {
  components: {
    Logout,
  },
  computed: {
    ...mapGetters('authentication', ['authenticatedUser']),
  },
};
</script>
